// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"cb51959d","188":"55458a7a","292":"4a681eeb","332":"12d31381","609":"995ffcdc","638":"222f8c1f","911":"b71ae103"}[chunkId] + ".chunk.css";
};